import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwareInboxClassicRoute: InvariantJiraRoute = {
	name: 'inbox-classic',
	path: '/jira/software/c/projects/:projectKey/inbox/:issueKey?',
};
